import React, { useEffect } from "react";
import { useAuthMethod } from "@crema/utility/AuthHooks";
import { useNavigate } from "react-router-dom";

function Logout() {
  const { logout } = useAuthMethod();
  const navigate = useNavigate();
  useEffect(() => {
    logout();
    navigate("/signin");
  }, []);

  return <div></div>;
}

export default Logout;
